import { PortalCloseButton } from "@components/ui/portal-close-button";

/**
 * The funnel's close control. Thin alias over the shared portaled button so
 * every modal in the flow closes from the same spot.
 */
export const FunnelCloseButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  /** Blocks the close while a completion the user just triggered is in flight. */
  disabled?: boolean;
}) => <PortalCloseButton onClick={onClick} disabled={disabled} />;
